import exportCompanyPriceApi from '@/api/post/company/company-price/export-company-price';
import exportDealerPriceApi from '@/api/post/dealer/export-company-dealer-price';
import Alert from '@/components/alert/alert-component';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Col, Row } from '@/components/grid/grid-component';
import Loader from '@/components/loader/loader-component';
import RadioButtonGroup from '@/components/react-hook-form-inputs/radio-button/radio-button-component';
import { useMutation } from '@/hooks/use-api';
import { BodyText } from '@/utils/global-fonts';
import { requiredValidationMessage } from '@/utils/validations';
import PropTypes from 'prop-types';

const modalRowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '0px',
};

const modalParentRowStyle = {
  marginLeft: '0px',
  marginBottom: '0px',
  padding: '24px',
};

const styledCol = {
  paddingLeft: '0px',
};

const priceTypeOptions = [
  { value: 'END_USER', label: 'End User Price' },
  { value: 'TRANSFER', label: 'Transfer Price' },
];

const radioContainerStyle = {
  marginRight: '80px',
};
const mainContainerStyle = { width: '100%', marginLeft: 5 };

/**
 * @param {object} root0 - The root object containing props
 * @param {Function} root0.onClose - Callback function to close the modal
 * @param {string} root0.companyId - company ID
 * @param {bool} root0.isDealer - if dealer company
 * @returns {JSX.Element} - The rendered JSX element
 */
const ExportPricingModal = ({ isDealer, companyId, onClose }) => {
  const [exportDealerPrice, { loading: exportDealerPriceListLoading }] =
    useMutation(exportDealerPriceApi);
  const [exportCompanyPrice, { loading }] = useMutation(exportCompanyPriceApi);

  const submitForm = (values) => {
    if (isDealer) {
      exportDealerPrice(companyId, values)
        .then(() => {
          Alert({
            icon: 'success',
            text: 'Prices exported successfully, please check your email inbox',
          });
          onClose();
        })
        .catch(() => {
          Alert({
            icon: 'error',
            text: 'Failed to export prices',
          });
          onClose();
        });
    } else {
      exportCompanyPrice(companyId, values)
        .then(() => {
          Alert({
            icon: 'success',
            text: 'Prices exported successfully, please check your email inbox',
          });
          onClose();
        })
        .catch(() => {
          Alert({
            icon: 'error',
            text: 'Failed to export prices',
          });
          onClose();
        });
    }
  };

  return (
    <FormWrapper defaultValues={{ price_type: null }} onSubmit={submitForm}>
      <Row style={modalParentRowStyle}>
        {loading || exportDealerPriceListLoading ? (
          <Row style={modalRowStyle}>
            <Loader dark />
          </Row>
        ) : (
          <>
            <Row style={modalRowStyle}>
              <Col style={styledCol} xs={12}>
                <BodyText>
                  Please select which pricing you would like to export
                </BodyText>
              </Col>
            </Row>

            <Row style={modalRowStyle}>
              <RadioButtonGroup
                radioContainerStyle={radioContainerStyle}
                mainContainerStyle={mainContainerStyle}
                options={priceTypeOptions}
                disabled={loading}
                name="price_type"
                registerOptions={{
                  required: requiredValidationMessage,
                }}
              />
            </Row>
          </>
        )}
      </Row>
      <SubmitCard
        padding="0"
        primaryButtonTitle="Export"
        primaryButtonType="submit"
        visible={loading || exportDealerPriceListLoading}
        primaryButtonDisabled={false}
        primaryButtonWidth="112px"
        submitClick={() => {}}
        submitClickSecondary={() => {
          onClose();
        }}
        secondaryButtonType="button"
        secondaryButtonDisabled={false}
        secondaryButtonWidth="112px"
        secondaryButtonTitle="Cancel"
      />
    </FormWrapper>
  );
};

ExportPricingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
  isDealer: PropTypes.bool.isRequired,
};

export default ExportPricingModal;
